import { render, staticRenderFns } from "./Newsblock.vue?vue&type=template&id=cb07a4f4"
import script from "./Newsblock.vue?vue&type=script&lang=js"
export * from "./Newsblock.vue?vue&type=script&lang=js"
import style0 from "./Newsblock.vue?vue&type=style&index=0&id=cb07a4f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports